import { render, staticRenderFns } from "./TablaComercios.vue?vue&type=template&id=87a16cba&scoped=true&"
import script from "./TablaComercios.vue?vue&type=script&lang=js&"
export * from "./TablaComercios.vue?vue&type=script&lang=js&"
import style0 from "./TablaComercios.vue?vue&type=style&index=0&id=87a16cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a16cba",
  null
  
)

export default component.exports